"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcBillingListItemHeader = class UcBillingListItemHeader extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    item;
    onItem(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("item");
    }
    messages;
    ux;
    dataMembers = ['messages', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                messages: {
                    newItem: this.$fn.pgettext("BillingListItem", "New item"),
                    editItem: this.$fn.pgettext("BillingListItem", "Edit item"),
                },
                ux: null,
            },
        };
    }
    get resourceTitle() {
        if (this.loaded) {
            return this.$fn.pgettext("BillingListItem", "Billing list item");
        }
        return null;
    }
    get resourceKey() {
        if (this.loaded) {
            return this.item.isNew ? this.messages.newItem : this.messages.editItem;
        }
        return null;
    }
    async act_1040167445267876_emit_6844_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_1040167445267876_clickPreventStop(event, scope) {
        return await this.actions.evh_1040167445267876_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_3601807637515735_emit_6848_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async act_3601807637515735_reloadSlickgrid_6850_getActionArgs($event) {
        return {
            grid: "register",
        };
    }
    async act_3601807637515735_request_6846_getActionArgs($event) {
        return {
            operation: "update_register_item",
            data: {
                id: this.item.id,
                etag: this.item.etag,
                locked: true,
            },
        };
    }
    async evh_3601807637515735_clickPreventStop(event, scope) {
        return await this.actions.evh_3601807637515735_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_4139696446929656_emit_6854_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async act_4139696446929656_reloadSlickgrid_6856_getActionArgs($event) {
        return {
            grid: "register",
        };
    }
    async act_4139696446929656_request_6852_getActionArgs($event) {
        return {
            operation: "update_register_item",
            data: {
                id: this.item.id,
                etag: this.item.etag,
                locked: false,
            },
        };
    }
    async evh_4139696446929656_clickPreventStop(event, scope) {
        return await this.actions.evh_4139696446929656_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_4700643919467772_emit_6860_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async act_4700643919467772_reloadSlickgrid_6862_getActionArgs($event) {
        return {
            grid: "register",
        };
    }
    async act_4700643919467772_request_6858_getActionArgs($event) {
        return {
            operation: "update_register_item",
            data: {
                id: this.item.id,
                etag: this.item.etag,
                void: true,
            },
        };
    }
    async evh_4700643919467772_clickPreventStop(event, scope) {
        return await this.actions.evh_4700643919467772_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_295664594794476_emit_6866_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async act_295664594794476_reloadSlickgrid_6868_getActionArgs($event) {
        return {
            grid: "register",
        };
    }
    async act_295664594794476_request_6864_getActionArgs($event) {
        return {
            operation: "update_register_item",
            data: {
                id: this.item.id,
                etag: this.item.etag,
                void: false,
            },
        };
    }
    async evh_295664594794476_clickPreventStop(event, scope) {
        return await this.actions.evh_295664594794476_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_8474446275270171_emit_6870_getActionArgs($event) {
        return {
            event: "deleted",
        };
    }
    async evh_8474446275270171_success(event, scope) {
        return await this.actions.evh_8474446275270171_success.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_1040167445267876_emit_6844 = new core_1.actions.EmitAction({
            actionArgs: this.act_1040167445267876_emit_6844_getActionArgs,
            displayName: "reload",
            events: [],
        });
        const evh_1040167445267876_clickPreventStop_6843 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_emit_6844,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_1040167445267876_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_clickPreventStop_6843],
        });
        const act_3601807637515735_emit_6848 = new core_1.actions.EmitAction({
            actionArgs: this.act_3601807637515735_emit_6848_getActionArgs,
            events: [],
        });
        const evh_3601807637515735_success_6847 = new core_1.actions.EventHandlerImpl({
            action: act_3601807637515735_emit_6848,
            event: "success",
            displayName: "emit",
        });
        const act_3601807637515735_reloadSlickgrid_6850 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_3601807637515735_reloadSlickgrid_6850_getActionArgs,
            events: [],
        });
        const evh_3601807637515735_success_6849 = new core_1.actions.EventHandlerImpl({
            action: act_3601807637515735_reloadSlickgrid_6850,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_3601807637515735_request_6846 = new core_1.actions.RequestAction({
            actionArgs: this.act_3601807637515735_request_6846_getActionArgs,
            displayName: "lock",
            events: [evh_3601807637515735_success_6847, evh_3601807637515735_success_6849],
        });
        const evh_3601807637515735_clickPreventStop_6845 = new core_1.actions.EventHandlerImpl({
            action: act_3601807637515735_request_6846,
            event: "click.prevent.stop",
            displayName: "lock",
        });
        const evh_3601807637515735_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3601807637515735_clickPreventStop_6845],
        });
        const act_4139696446929656_emit_6854 = new core_1.actions.EmitAction({
            actionArgs: this.act_4139696446929656_emit_6854_getActionArgs,
            events: [],
        });
        const evh_4139696446929656_success_6853 = new core_1.actions.EventHandlerImpl({
            action: act_4139696446929656_emit_6854,
            event: "success",
            displayName: "emit",
        });
        const act_4139696446929656_reloadSlickgrid_6856 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_4139696446929656_reloadSlickgrid_6856_getActionArgs,
            events: [],
        });
        const evh_4139696446929656_success_6855 = new core_1.actions.EventHandlerImpl({
            action: act_4139696446929656_reloadSlickgrid_6856,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_4139696446929656_request_6852 = new core_1.actions.RequestAction({
            actionArgs: this.act_4139696446929656_request_6852_getActionArgs,
            displayName: "lock",
            events: [evh_4139696446929656_success_6853, evh_4139696446929656_success_6855],
        });
        const evh_4139696446929656_clickPreventStop_6851 = new core_1.actions.EventHandlerImpl({
            action: act_4139696446929656_request_6852,
            event: "click.prevent.stop",
            displayName: "lock",
        });
        const evh_4139696446929656_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4139696446929656_clickPreventStop_6851],
        });
        const act_4700643919467772_emit_6860 = new core_1.actions.EmitAction({
            actionArgs: this.act_4700643919467772_emit_6860_getActionArgs,
            events: [],
        });
        const evh_4700643919467772_success_6859 = new core_1.actions.EventHandlerImpl({
            action: act_4700643919467772_emit_6860,
            event: "success",
            displayName: "emit",
        });
        const act_4700643919467772_reloadSlickgrid_6862 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_4700643919467772_reloadSlickgrid_6862_getActionArgs,
            events: [],
        });
        const evh_4700643919467772_success_6861 = new core_1.actions.EventHandlerImpl({
            action: act_4700643919467772_reloadSlickgrid_6862,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_4700643919467772_request_6858 = new core_1.actions.RequestAction({
            actionArgs: this.act_4700643919467772_request_6858_getActionArgs,
            displayName: "lock",
            events: [evh_4700643919467772_success_6859, evh_4700643919467772_success_6861],
        });
        const evh_4700643919467772_clickPreventStop_6857 = new core_1.actions.EventHandlerImpl({
            action: act_4700643919467772_request_6858,
            event: "click.prevent.stop",
            displayName: "lock",
        });
        const evh_4700643919467772_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4700643919467772_clickPreventStop_6857],
        });
        const act_295664594794476_emit_6866 = new core_1.actions.EmitAction({
            actionArgs: this.act_295664594794476_emit_6866_getActionArgs,
            events: [],
        });
        const evh_295664594794476_success_6865 = new core_1.actions.EventHandlerImpl({
            action: act_295664594794476_emit_6866,
            event: "success",
            displayName: "emit",
        });
        const act_295664594794476_reloadSlickgrid_6868 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_295664594794476_reloadSlickgrid_6868_getActionArgs,
            events: [],
        });
        const evh_295664594794476_success_6867 = new core_1.actions.EventHandlerImpl({
            action: act_295664594794476_reloadSlickgrid_6868,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_295664594794476_request_6864 = new core_1.actions.RequestAction({
            actionArgs: this.act_295664594794476_request_6864_getActionArgs,
            displayName: "lock",
            events: [evh_295664594794476_success_6865, evh_295664594794476_success_6867],
        });
        const evh_295664594794476_clickPreventStop_6863 = new core_1.actions.EventHandlerImpl({
            action: act_295664594794476_request_6864,
            event: "click.prevent.stop",
            displayName: "lock",
        });
        const evh_295664594794476_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_295664594794476_clickPreventStop_6863],
        });
        const act_8474446275270171_emit_6870 = new core_1.actions.EmitAction({
            actionArgs: this.act_8474446275270171_emit_6870_getActionArgs,
            events: [],
        });
        const evh_8474446275270171_success_6869 = new core_1.actions.EventHandlerImpl({
            action: act_8474446275270171_emit_6870,
            event: "success",
            displayName: "emit",
        });
        const evh_8474446275270171_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8474446275270171_success_6869],
        });
        return {
            act_1040167445267876_emit_6844,
            evh_1040167445267876_clickPreventStop_6843,
            evh_1040167445267876_clickPreventStop,
            act_3601807637515735_emit_6848,
            evh_3601807637515735_success_6847,
            act_3601807637515735_reloadSlickgrid_6850,
            evh_3601807637515735_success_6849,
            act_3601807637515735_request_6846,
            evh_3601807637515735_clickPreventStop_6845,
            evh_3601807637515735_clickPreventStop,
            act_4139696446929656_emit_6854,
            evh_4139696446929656_success_6853,
            act_4139696446929656_reloadSlickgrid_6856,
            evh_4139696446929656_success_6855,
            act_4139696446929656_request_6852,
            evh_4139696446929656_clickPreventStop_6851,
            evh_4139696446929656_clickPreventStop,
            act_4700643919467772_emit_6860,
            evh_4700643919467772_success_6859,
            act_4700643919467772_reloadSlickgrid_6862,
            evh_4700643919467772_success_6861,
            act_4700643919467772_request_6858,
            evh_4700643919467772_clickPreventStop_6857,
            evh_4700643919467772_clickPreventStop,
            act_295664594794476_emit_6866,
            evh_295664594794476_success_6865,
            act_295664594794476_reloadSlickgrid_6868,
            evh_295664594794476_success_6867,
            act_295664594794476_request_6864,
            evh_295664594794476_clickPreventStop_6863,
            evh_295664594794476_clickPreventStop,
            act_8474446275270171_emit_6870,
            evh_8474446275270171_success_6869,
            evh_8474446275270171_success,
            reload: act_1040167445267876_emit_6844,
            lock: act_295664594794476_request_6864,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcBillingListItemHeader.prototype, "item", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('item'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcBillingListItemHeader.prototype, "onItem", null);
UcBillingListItemHeader = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcBillingListItemHeader);
exports.default = UcBillingListItemHeader;
vue_property_decorator_1.Vue.component("UcBillingListItemHeader", UcBillingListItemHeader);
